import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  Brain,
  Mail,
  MapPin,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Heart
} from 'lucide-react';
import LegalModal from './LegalModal';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #1f2937, #374151);
  color: white;
  padding: 3rem 1rem 1rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const FooterSection = styled.div`
  h3 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #f9fafb;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  li {
    margin-bottom: 0.5rem;
  }

  a {
    color: #d1d5db;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: #6366f1;
    }
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 1rem;
`;

const LogoIcon = styled.div`
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Description = styled.p`
  color: #d1d5db;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialLink = styled.a`
  width: 40px;
  height: 40px;
  background: #374151;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d1d5db;
  transition: all 0.3s;

  &:hover {
    background: #6366f1;
    color: white;
    transform: translateY(-2px);
  }
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  color: #d1d5db;
`;

const FooterBottom = styled.div`
  border-top: 1px solid #374151;
  padding-top: 2rem;
  text-align: center;
  color: #9ca3af;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
`;

const Copyright = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;

  a {
    color: #9ca3af;
    text-decoration: none;
    font-size: 0.9rem;
    transition: color 0.3s;

    &:hover {
      color: #6366f1;
    }
  }
`;

const Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showKvkk, setShowKvkk] = useState(false);

  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <Logo>
            <LogoIcon>
              <Brain size={24} />
            </LogoIcon>
            İşHazır
          </Logo>
          <Description>
            AI teknolojisi ile kariyerinizi yeni seviyeye taşıyın.
            CV hazırlama ve mülakat simülasyonu konusunda uzmanlaşın.
          </Description>
          <SocialLinks>
            <SocialLink href="#" aria-label="Facebook">
              <Facebook size={20} />
            </SocialLink>
            <SocialLink href="#" aria-label="Twitter">
              <Twitter size={20} />
            </SocialLink>
            <SocialLink href="#" aria-label="Instagram">
              <Instagram size={20} />
            </SocialLink>
            <SocialLink href="#" aria-label="LinkedIn">
              <Linkedin size={20} />
            </SocialLink>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <h3>Hızlı Linkler</h3>
          <ul>
            <li>
              <Link to="/">Ana Sayfa</Link>
            </li>
            <li>
              <Link to="/cv-analyzer">CV Analizi</Link>
            </li>
            <li>
              <Link to="/interview-simulator">Mülakat Simülasyonu</Link>
            </li>
            <li>
              <Link to="/pricing">30 Gün Premium Pass</Link>
            </li>
          </ul>
        </FooterSection>

        <FooterSection>
          <h3>Özellikler</h3>
          <ul>
            <li>
              <a href="#">AI CV Analizi</a>
            </li>
            <li>
              <a href="#">Mülakat Pratiği</a>
            </li>
            <li>
              <a href="#">Ön Yazı Hazırlama</a>
            </li>
            <li>
              <a href="#">Kariyer Danışmanlığı</a>
            </li>
            <li>
              <a href="#">İş İlanları</a>
            </li>
          </ul>
        </FooterSection>

        <FooterSection>
          <h3>İletişim</h3>
          <ContactInfo>
            <Mail size={16} />
            <span>info@ishazir.com</span>
          </ContactInfo>

          <ContactInfo>
            <MapPin size={16} />
            <span>İstanbul, Türkiye</span>
          </ContactInfo>
        </FooterSection>
      </FooterContent>

      <FooterBottom>
        <Copyright>
          © 2024 İşHazır. Tüm hakları saklıdır.
          <Heart size={16} color="#ef4444" />
        </Copyright>
        <FooterLinks>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setShowPrivacy(true);
            }}
          >
            Gizlilik Politikası
          </a>
          <a href="#">Kullanım Şartları</a>
          <Link to="/cerez-politikasi">Çerez Politikası</Link>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setShowKvkk(true);
            }}
          >
            KVKK
          </a>
        </FooterLinks>
      </FooterBottom>

      <LegalModal
        open={showPrivacy}
        onClose={() => setShowPrivacy(false)}
        title="Gizlilik Politikası"
      >
        <p>
        İSHAZIR.COM — GİZLİLİK POLİTİKASI

Son Güncelleme: 10.12.2025

Bu Gizlilik Politikası, ishazir.com (“Platform”) üzerinden sunulan yapay zekâ destekli CV analiz hizmetinden yararlanan kullanıcıların kişisel verilerinin nasıl toplandığı, kullanıldığı, korunduğu ve işlendiğini açıklamak amacıyla hazırlanmıştır.

Platform Doğukan Ilgaz tarafından bireysel olarak işletilmektedir.

Platformu kullanarak bu Gizlilik Politikasını kabul etmiş sayılırsınız.

1. Toplanan Bilgiler

ishazir.com üzerinde aşağıdaki bilgiler işlenebilir:

1.1. Kullanıcı Tarafından Sağlanan Bilgiler

Yüklenen CV dosyası (PDF)

CV içeriğindeki bilgiler

Kullanıcı tarafından gönüllü olarak iletilen görüntü, metin, içerik

Destek ve iletişim mesajları

1.2. Teknik Bilgiler

IP adresi

Tarayıcı ve cihaz türü

Çerez bilgileri

Oturum logları

Kullanım istatistikleri

2. CV Dosyalarının Saklanmaması

Platforma yüklenen CV dosyaları:

Sunucuda depolanmaz,

Hizmet tamamlandıktan sonra otomatik olarak silinir,

Kullanıcı dosyaları hiçbir şekilde üçüncü taraflara aktarılmaz veya arşivlenmez.

Bu yaklaşım gizlilik ve veri minimizasyonu prensiplerine uygundur.

3. OpenAI Kullanımı (Yapay Zekâ İşleme Süreci)

Platform üzerinde yapılan CV analizleri, OpenAI API kullanılarak gerçekleştirilir.

Bu kapsamda:

CV içeriği analiz işlemi için OpenAI API’ye anlık olarak iletilir,

OpenAI bu içeriği yalnızca analiz işlemini gerçekleştirmek için kullanır,

Platform tarafında hiçbir veri saklanmaz,

İşleme bittikten sonra veri sistemden silinir.

Kullanıcı hizmeti kullanarak bu teknik işleme sürecini kabul eder.

4. Verilerin Kullanım Amaçları

Toplanan veriler aşağıdaki amaçlarla kullanılabilir:

CV analiz hizmetinin çalışmasını sağlamak

Kullanıcıya geri bildirim sunmak

Teknik sorunları tespit etmek

Kötüye kullanım ve güvenlik ihlallerini engellemek

İletişim talebi oluşması durumunda geri dönüş sağlamak

Açık rıza kapsamında bilgilendirme yapmak

5. Çerez Kullanımı

Platform, kullanıcı deneyimini geliştirmek amacıyla aşağıdaki çerez türlerini kullanabilir:

Zorunlu çerezler (oturum yönetimi)

Performans çerezleri (isteğe bağlı)

Çerezler üzerinden kişisel veri işlenmesi yoktur.

6. Verilerin Üçüncü Taraflarla Paylaşımı

ishazir.com;

Kullanıcı verilerini satmaz,

Reklam amaçlı üçüncü taraflarla paylaşmaz,

CV bilgilerini hiçbir kurum veya şahısla paylaşmaz.

Veriler yalnızca:

OpenAI API (analiz işlemi için teknik aktarım)

Kanunen zorunlu hâllerde resmî kurum talepleri

kapsamında paylaşılabilir.

7. Veri Güvenliği

Platform;

Dosya yüklemelerini güvenli şekilde işler

CV’leri sunucuda depolamaz

Sistem loglarını yetkisiz erişime karşı korur

HTTPS ve güvenli iletişim protokollerini kullanır

Düzenli güvenlik kontrolleri yapar

8. Kullanıcı Hakları

Kullanıcılar, KVKK’nın 11. maddesi kapsamında:

Kişisel veri işlendiğini öğrenme

Verilere erişme

Silinmesini talep etme

Düzeltme talep etme

İşleme amacını öğrenme

Aktarılan üçüncü tarafları öğrenme

İşlemeye itiraz etme

haklarına sahiptir.

Bu talepler aşağıdaki e-posta adresine iletilebilir:

📩 info@ishazir.com

9. Veri Sorumlusu

Veri Sorumlusu: Doğukan Ilgaz
Yerleşim: İstanbul / Küçükçekmece
E-posta: info@ishazir.com

10. Gizlilik Politikasındaki Değişiklikler

ishazir.com bu gizlilik politikasını güncelleme hakkını saklı tutar.
Güncellenmiş politika platform üzerinde yayımlandığı anda geçerli olur.
        </p>
      </LegalModal>

      <LegalModal
        open={showKvkk}
        onClose={() => setShowKvkk(false)}
        title="KVKK Aydınlatma Metni"
      >
        <p>
        İSHAZIR.COM – KVKK AYDINLATMA METNİ (GÜNCEL)

Aydınlatma Metni
6698 Sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) Kapsamında

Bu aydınlatma metni, ishazir.com platformu üzerinden sunulan yapay zekâ destekli CV analiz hizmeti kapsamında işlenen kişisel verilere ilişkin olarak KVKK’nın 10. maddesi uyarınca hazırlanmıştır.

Platformun veri sorumlusu Doğukan Ilgaz’dır.

1. Veri Sorumlusunun Kimliği

Veri Sorumlusu: Doğukan Ilgaz
Adres: İstanbul / Küçükçekmece
E-posta: info@ishazir.com

İshazir.com bir şirket tüzel kişiliği değil, bireysel hizmet sağlayıcı tarafından işletilen dijital bir platformdur.

2. İşlenen Kişisel Veriler

Kullanıcı tarafından yüklenen CV dosyası

CV içeriğindeki bilgiler

E-posta adresi (kullanıcı iletişimi)

Teknik veriler: IP adresi, tarayıcı bilgisi, çerezler, oturum kayıtları

3. CV Verilerinin Saklanmaması

Yüklenen CV dosyaları sunucuda saklanmaz

CV içeriği işlendikten sonra otomatik olarak silinir

Yapay zekâ analizi OpenAI API üzerinden yapılır

Veri saklama, arşivleme veya üçüncü taraflara aktarım yapılmaz

Bu süreç KVKK’nın veri minimizasyonu ilkesine uygundur.

4. Kişisel Verilerin İşlenme Amaçları

CV analizinin yapay zekâ aracılığıyla gerçekleştirilmesi

Kullanıcıya analiz sonuçlarının sunulması

Güvenlik süreçleri (log kayıtları, kötüye kullanımı önleme)

Kullanıcı destek süreçlerinin yürütülmesi

Açık rıza alınması hâlinde bilgilendirme, geri bildirim ve gelişim duyuruları

5. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebepler

Veriler:

Kullanıcı yüklemeleri

Form verileri

Tarayıcı tarafından aktarılan teknik bilgiler

yoluyla alınır.

Hukuki sebep:

KVKK m.5/2(c): Hizmet sunumu için zorunlu veri işleme

KVKK m.5/2(f): Meşru menfaat (güvenlik, log kayıtları)

KVKK m.5/1: Açık rıza gereken durumlar

6. Kişisel Verilerin Aktarılması
OpenAI API (yurt dışına teknik aktarım)

CV içeriği, yalnızca analiz işleminin yapılabilmesi için OpenAI API’ye iletilir.
Bu aktarım:

Sadece analiz amacıyla kullanılır

Saklama yapılmaz

OpenAI veri politikalarına uygundur

Kullanıcı hizmeti kullanarak bu teknik aktarımı kabul etmiş sayılır.

Resmî kurumlar

Sadece hukuken zorunlu hâllerde paylaşım yapılabilir.

7. KVKK Kapsamındaki Haklarınız

Kullanıcılar:

İşlenip işlenmediğini öğrenme

Bilgi talep etme

Silme/düzeltme talep etme

İtiraz hakkı

Tazminat talebi

haklarına sahiptir.

8. Başvuru Yöntemi

KVKK kapsamındaki tüm talepler:

📩 info@ishazir.com

adresine iletilebilir.
Başvurular 30 gün içinde sonuçlandırılır.
        </p>
      </LegalModal>
    </FooterContainer>
  );
};

export default Footer;

